import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topicsData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-200/60"
            >
              <div className={`w-2.5 h-2.5 rounded-full ${item.color} flex-shrink-0`}></div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</span>
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}